'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './bicycle_parking.routes';

export class BicycleParkingComponent {
  /*@ngInject*/
  constructor($state, $scope, $rootScope, fetch, lookup, userService, $timeout, baseConfigService, $http, $stateParams) {
    const vm = this;
    this.$scope = $scope;
    this.$state = $state;
    this.fetch = fetch;
    this.lookup = lookup;
    this.$stateParams = $stateParams;
    this.userService = userService;
    this.$timeout = $timeout;
    this.$http = $http;
    this.baseConfigService = baseConfigService;

    $scope.adminUnlocked = false; // track admin manual unlock
    $scope.policy_name = 'Bicycle Parking Minimum';
    $scope.attachmentData = $scope.attachmentData || {};
    $scope.submissions = [];
    $scope.savemode = null
    $scope.baseUrl = baseConfigService.getBaseURL();

    $scope.bicycleParkingMinimum = false;
    $scope.initialLoad = true;
    $scope.parking = {};
    $scope.submitmode = null;


    $scope.pendingChanges = false;
    $scope.showPanel = null;

    $scope.togglePanel = function (panelName) {
      $scope.showPanel = panelName;
    };

    $scope.setPending = function () {
      console.log('set pending ran')
      console.log($scope.initialLoad);
      if (!$scope.initialLoad) {
        $scope.savemode = 'parking';
        $scope.pendingChanges = true;
      }
    }

    $scope.getStationTier = function (station) {
      if (station) {
        $scope.loadingData = true;
      }
      fetch.getItem(`api/data/parking/station-tiers/${$scope.currentJurisdiction}`, $scope.currentSelectedStationId)
        .then(response => {
          $scope.currentStation = response.data[0];
          $scope.loadingData = false;
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    };

    $scope.isFormEditable = function () {
      if (!$scope.currentParkingPolicy) return true;

      var role = $scope.currentUser && $scope.currentUser.role;

      // Find matching submission status for current policy
      var submission = null;
      if ($scope.parkingStatus) {
        for (var i = 0; i < $scope.parkingStatus.length; i++) {
          if ($scope.parkingStatus[i].submission_policy_name === $scope.currentParkingPolicy.policy_name) {
            submission = $scope.parkingStatus[i];
            break;
          }
        }
      }
      // Not yet submitted — allow editing
      if (!submission || !submission.submitted) return true;

      // Admins can edit if they've manually unlocked
      if (role === 'Administrator') {
        return $scope.adminUnlocked;
      }

      // Admin set it to "Needs Work" — allow editing without withdraw
      if (submission.status === 'Needs Work') return true;

      // Otherwise submitted and locked — user must withdraw to edit
      return false;
    };

    $scope.$watch(
      function () {
        return $scope.currentParkingPolicy
      },
      function () {
        $scope.adminUnlocked = false;
        $scope.formReadOnly = !$scope.isFormEditable();
        $scope.withdrawnNotice = false;
        $scope.needsWorkNotice = false;
        if ($scope.parkingStatus && $scope.policy_name) {
          var sub = _.find($scope.parkingStatus, { submission_policy_name: $scope.policy_name });
          if (sub && sub.submitted && sub.status === 'Needs Work') { $scope.needsWorkNotice = true; }
        }
      }
    );

    $scope.$watch('parkingStatus', function () {
      if (!$scope.currentParkingPolicy) return;
      $scope.formReadOnly = !$scope.isFormEditable();
    }, true);

    $scope.toggleAdminUnlock = function () {
      $scope.adminUnlocked = !$scope.adminUnlocked;
      $scope.formReadOnly = !$scope.isFormEditable();
    };

      $scope.withdrawSubmission = function () {
  var confirmWithdraw = window.confirm(
    'Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.'
  );
  if (!confirmWithdraw) return;

  // Find matching submission using $scope.policy_name (current active tab policy)
  var submission = null;
  if ($scope.parkingStatus) {
    for (var i = 0; i < $scope.parkingStatus.length; i++) {
      if ($scope.parkingStatus[i].submission_policy_name === $scope.policy_name) {
        submission = $scope.parkingStatus[i];
        break;
      }
    }
  }

  if (!submission || !submission.submission_id) {
    console.error('No matching submission found to withdraw');
    return;
  }

  var payload = {
    submission_id: submission.submission_id,
    submitted: false,
    status: null
  };

  fetch.updateItem('api/data/submissions/update-status', payload)
    .then(function () {
      submission.submitted = false;
      submission.status = null;

      if (
        $scope.checkParking &&
        $scope.checkParking.submission_id === submission.submission_id
      ) {
        $scope.checkParking = null;
        $scope.bicycleParkingMinCheck = false;
        $scope.parking.bicycleParkingMinCheck = false;
        if ($scope.bicycleParkingMinimum) {
          $scope.bicycleParkingMinimum.forEach(function (el) {
            el.submitted = false;
          });
        }
      };

      $scope.formReadOnly = false;

      // Clear form fields — preserve only identity fields
      var formId = $scope.currentParkingPolicy ? $scope.currentParkingPolicy.parking_form_id : null;
      $scope.currentParkingPolicy = { parking_form_id: formId };

      // Show withdrawn notification
      $scope.withdrawnNotice = true;
      $scope.needsWorkNotice = false;
      $scope.success = false;
    })
    .catch(function (err) {
      console.error('Withdraw failed:', err);
      alert('There was an error withdrawing the submission. Please try again.');
    });
};

    $scope.addToSubmissions = function (submission) {
      const index = $scope.submissions.indexOf(submission);
      if (index > -1) { // only splice array when item is found
        $scope.submissions.splice(index, 1); // 2nd parameter means remove one item only
      } else {
        $scope.submissions.push(submission);
      }

      if ($scope.submissions.length > 0) {
        $scope.submitmode = 'parking';
      } else {
        $scope.submitmode = null;
      }
    }

    $scope.getSubmissionStatus = function () {
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, `Parking`)
        .then(response => {
          $scope.parkingStatus = response.data;
          console.log('Parking status response:', response.data);
          $scope.checkParking = (_.filter(response.data, { submission_policy_name: `Bicycle Parking Minimum`, submitted: true}))[0];

          console.log('Loaded policy submissions:', $scope.parkingStatus);

        })
        .catch(err => {
          console.log(err);
        })
    }

    $scope.updateSubmissionStatus = function (row, newStatus) {

      if (!row || !row.submission_id) {
        console.error('submission_id is missing:', row);
        return;
      }

      const originalStatus = row.status;

      // Update the UI immediately
      row.status = newStatus;

      const updateData = {
        submission_id: row.submission_id,
        status: newStatus
      };

      console.log('Updating submission:', {
        id: row.submission_id,
        status: newStatus
      });

      fetch.updateItem('api/data/submissions/update-status', updateData)
        .then(response => {
          $timeout(() => {
            $scope.successMessage = 'Status updated successfully';
          });
        })
        .catch(err => {
          console.error('Error updating status:', err);
          $timeout(() => {
            // Revert the status if update failed
            row.status = originalStatus;
            $scope.error = 'Failed to update status';
          });
        });
    };

    $scope.getStationbyID = function (station) {
      if (station) {
        $scope.currentSelectedStationId = station;
        lookup.setCurrentStation(station);
      }

      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);

      $scope.getSubmissionStatus();
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, 'Parking')
        .then(response => {

          $scope.currentStation = response.data[0];

          $scope.complementaryParking = _.filter(response.data, { submission_policy_name: 'Complementary Parking Management Policy' });
          if ($scope.complementaryParking.length > 0) {
            $scope.complementaryParking.forEach(element => {
              if (element.submitted == true) {
                $scope.complementaryParkCheck = true;
              }
            });
          }
          $scope.unbundledParking = _.filter(response.data, { submission_policy_name: 'Unbundled Parking' });
          if ($scope.unbundledParking.length > 0) {
            $scope.unbundledParking.forEach(element => {
              if (element.submitted == true) {
                $scope.unbundledParkCheck = true;
              }
            });
          }
          $scope.sharedParking = _.filter(response.data, { submission_policy_name: 'Shared Parking' });
          if ($scope.sharedParking.length > 0) {
            $scope.sharedParking.forEach(element => {
              if (element.submitted == true) {
                $scope.sharedParkCheck = true;
              }
            });
          }
          $scope.vehicleParkingMaximum = _.filter(response.data, { submission_policy_name: 'Vehicle Parking Maximum' });
          if ($scope.vehicleParkingMaximum.length > 0) {
            $scope.vehicleParkingMaximum.forEach(element => {
              if (element.submitted == true) {
                $scope.vehicleParkingMaxCheck = true;
              }
            });
          }
          $scope.vehicleParkingMinimum = _.filter(response.data, { submission_policy_name: 'Vehicle Parking Minimum' });
          if ($scope.vehicleParkingMinimum.length > 0) {
            $scope.vehicleParkingMinimum.forEach(element => {
              if (element.submitted == true) {
                $scope.vehicleParkingMinCheck = true;
              }
            });
          }
          $scope.bicycleParkingMinimum = _.filter(response.data, { submission_policy_name: 'Bicycle Parking Minimum' });
          if ($scope.bicycleParkingMinimum.length > 0) {
            $scope.bicycleParkingMinimum.forEach(element => {
              if (element.submitted == true) {
                $scope.bicycleParkingMinCheck = true;
              }
            });
          }
          $scope.getStationTier($scope.currentSelectedStationId);
          return $scope.getCurrentParkingPolicy($scope.policy_name);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }


    $scope.getCurrentParkingPolicy = function (policy_name) {
      if (policy_name) {
        $scope.policy_name = policy_name;
      }
      fetch.getAllItems(`api/data/getParkingForm/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}/${encodeURIComponent($scope.policy_name)}`)
        .then(response => {

          $scope.currentParkingPolicy = response.data[0];

          console.log('parking_form_id:', $scope.currentParkingPolicy.parking_form_id);
          $scope.initialLoad = false;
          console.log($scope.initialLoad);
          // if(type === 'Complementary Parking Management Policy'){
          //   if($scope.currentStationPolicy.tdm_policy_new_dev){
          //     $scope.tdm_policy_new_dev_checked = true;
          //   }
          //   if($scope.currentStationPolicy.curb_strategy_management){
          //     $scope.curb_strategy_management_checked = true;
          //   }
          //   if($scope.currentStationPolicy.parking_benefit_district){
          //     $scope.parking_benefit_district_checked = true;
          //   }
          //   if($scope.currentStationPolicy.demand_responsive_price){
          //     $scope.demand_responsive_price_checked = true;
          //   }
          //   if($scope.currentStationPolicy.priced_park){
          //     $scope.priced_park_checked = true;
          //   }
          // }
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })

    }


    $scope.updateCurrentParkingPolicy = function () {
      $scope.formSubmitted = true;
      if ($scope.parkingForm.$invalid) {
        $scope.saving = false;
        return;
      }

      // Ensure cleared fields send `null` instead of empty strings or undefined values
      Object.keys($scope.currentParkingPolicy).forEach(key => {
        if ($scope.currentParkingPolicy[key] === "" || $scope.currentParkingPolicy[key] === undefined) {
          $scope.currentParkingPolicy[key] = null;

        }
      });

      // Add parking_form_id to the payload
      $scope.currentParkingPolicy.parking_form_id = $scope.currentParkingPolicy.parking_form_id;

      console.log("Payload being sent:", $scope.currentParkingPolicy);

      fetch.updateItem(`api/data/parking/forms/update`, $scope.currentParkingPolicy)
        .then(response => {

          $scope.saved = true;
          $scope.saving = false;
          $scope.pendingChanges = false;
          setTimeout(() => {
            // $scope.submitmode = null;
            $scope.saved = false;
            $scope.savemode = null;
            $scope.$apply();
          }, 4000);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    $scope.submitParking = function () {
      console.log($scope.parking.bicycleParkingMinCheck)
      $scope.formSubmitted = true;
      $scope.saving = true;
      var upsertData = []; // Initialize upsertData array

      $scope.upsertData = []; // Reset or initialize upsert data array


      if ($scope.parking.complementaryParkCheck && $scope.complementaryParking.length > 0) {
        $scope.complementaryParking.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              complementary_parking_management: true,
              submitted: true,
            })
          }
        });
      }

      if ($scope.parking.unbundledParkCheck && $scope.unbundledParking.length > 0) {
        $scope.unbundledParking.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              unbundled_parking: true,
              submitted: true,
            })
          }
        });
      }

      if ($scope.parking.sharedParkCheck && $scope.sharedParking.length > 0) {
        $scope.sharedParking.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              shared_parking: true,
              submitted: true,
            })
          }
        });
      }

      if ($scope.parking.vehicleParkingMaxCheck && $scope.VehicleParkingMaximum.length > 0) {
        $scope.VehicleParkingMaximum.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              vehicle_parking_maximum: true,
              submitted: true,
            })
          }
        });
      }

      if ($scope.parking.vehicleParkingMinCheck && $scope.vehicleParkingMinimum.length > 0) {
        $scope.vehicleParkingMinimum.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              vehicle_parking_minimum: true,
              submitted: true,
            })
          }
        });
      }

      if ($scope.parking.bicycleParkingMinCheck && $scope.bicycleParkingMinimum.length > 0) {
        $scope.bicycleParkingMinimum.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              bicycle_parking_minimum: true,
              submitted: true,
            })
          }
        });
      }

      // Add submission data to upsertData
      // $scope.upsertData.push($scope.currentStationPolicy);



      // $scope.upsertData = _.union($scope.stationCompleteStreets, $scope.stationProjectPrioritization, $scope.stationGapAnalysis, $scope.stationMobilityHubPlanning);

      fetch.updateItem('api/data/submissions/update', upsertData)
        .then(response => {

          $scope.saving = false;
          $scope.submissions = [];
          $scope.saved = true;
          $scope.pendingChanges = false;
          $scope.getSubmissionStatus();
          setTimeout(() => {
            $scope.submitmode = null;
            $scope.saved = false;
            $scope.$apply();
          }, 2000);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }


    /**
* Update station area dropdown based on jurisdiction selected
* @param {*} jurisdiction 
*/
    $scope.getStationAreaList = function (jurisdiction) {
      // Check for sta_recid parameter from $stateParams
      const staRecId = $stateParams.sta_recid;

      lookup.setJurisdiction(jurisdiction);
      fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
        .then(response => {

          $scope.stationAreas = response.data;

          // Set currentSelectedStationId based on sta_recid
          if (staRecId) {
            $scope.currentSelectedStationId = staRecId;
          } else if (lookup.getCurrentStation()) {
            $scope.currentSelectedStationId = lookup.getCurrentStation();
          }

          // Call getStationbyID() after setting currentSelectedStationId
          if ($scope.currentSelectedStationId) {
            $scope.getStationbyID($scope.currentSelectedStationId);
          }
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    // File upload functions 

    $scope.initializeField = function (fieldId) {
      if (!$scope.attachmentData[fieldId]) {
        $scope.attachmentData[fieldId] = {
          fileName: null,
          file: null,
          isFileSelected: false
        };
      }
    };

    // Function to open the file dialog
    $scope.openFileDialog = function (fieldId) {
      $timeout(function () {
        document.getElementById('fileInput' + fieldId).click();
      }, 0);
    };

    // Function to handle file changes
    $scope.fileChanged = function (fieldId, element) {
      $scope.initializeField(fieldId);  // Ensure field is initialized

      var file = element.files[0];
      if (file) {
        // Check if the file type is PDF, Word document, or Excel file
        if (
          file.type !== 'application/pdf' &&
          file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && // For .docx
          file.type !== 'application/msword' && // For .doc
          file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && // For .xlsx
          file.type !== 'application/vnd.ms-excel' // For .xls
        ) {
          alert('Please select a PDF, Word document, or Excel file.');
          element.value = ''; // Reset input to clear the wrong file type
          return;
        }

        $scope.attachmentData[fieldId].fileName = file.name;
        $scope.attachmentData[fieldId].file = file;
        $scope.attachmentData[fieldId].isFileSelected = true;

        $scope.$apply();
      }
    };

    $scope.clearFile = function (ngmodel) {
      console.log(ngmodel);
      var fileInput = document.getElementById(`${ngmodel}`);
      console.log(fileInput);
      if (fileInput) {
        fileInput.value = ''; // clears the file input
        // Clear any associated model/preview values
        $scope[ngmodel] = '';
        $scope[`${ngmodel}_preview`] = '';
        $scope[`fileUploading_${ngmodel}`] = false;

        // If there's a form control, reset its validation state
        if ($scope.form && $scope.form[ngmodel]) {
          $scope.form[ngmodel].$setPristine();
          $scope.form[ngmodel].$setUntouched();
        }
      }
    };

    $scope.uploadFile = function (ngmodelfile) {
      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
      console.log(ngmodel);
      $scope[`fileUploading_${ngmodelfile}`] = true;
      var file = document.getElementById(`${ngmodelfile}`).files[0];

      if (!file) {
        console.error('No file selected');
        return;
      }

      var fileUpload = {
        fileName: file.name,
        fileType: file.type
      };

      // Using POST to get the signed URL and public URL
      fetch.updateItem('api/data/get-signed-url', fileUpload)
        .then(response => {
          console.log('Signed URL:', response.data.signedUrl);
          console.log('Public URL:', response.data.publicUrl);

          // Use the signed URL to upload the file
          return $http({
            method: 'PUT',
            url: response.data.signedUrl,
            data: file,
            headers: {
              'Content-Type': file.type,
              // 'x-amz-acl': 'public-read' // Ensure the file is publicly readable
            }
          })
            .then(() => {
              // After successful upload, store the public URL in the scope
              $scope.currentParkingPolicy[ngmodel] = response.data.publicUrl;
              return response.data.publicUrl; // Return the public URL for further use
            });
        })
        .then(publicUrl => {
          console.log('Upload successful');
          console.log('Public URL:', publicUrl);

          // Update UI state
          $scope[`fileUploading_${ngmodelfile}`] = false;
          $scope[`${ngmodelfile}`] = '';
          $scope.clearFile(ngmodelfile);
          $scope.uploadSuccess = true;
        })
        .catch(error => {
          console.error('Error:', error);
          alert('Upload failed');
        });
    };

    $scope.checkSubstring = function (input) {
      return input && input.length >= 4 && input.substring(0, 4) === 'http';
    };

    $scope.removeFile = function (ngmodel) {
      console.log(ngmodel);
      $scope.currentParkingPolicy[ngmodel] = '';
      $scope.setPending();
      $scope.savemode = 'parking';
      $scope.pendingChanges = true;
    };

  }

  $onInit() {
    this.$scope.submissionActivity = [];

    this.userService.getCurrentUser()
      .then(response => {

        this.$scope.currentUser = response.data;
        this.userService.setCurrentUser(response.data);
        this.$scope.currentParkingPolicy = {};
        return this.getJurisdictionList();
      })
      .catch(err => {
        console.log(err);
        if (err.status === 403) {
          this.$state.go('login');
        }
      })
  }

  getJurisdictionList() {
    this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list')
      .then(response => {
        this.$scope.loading = false;
        this.$scope.jurisdictions = response.data;

        // Check if user role is Administrator
        if (this.$scope.currentUser.role === 'Administrator') {
          console.log("admin");
          // Check for the jurisdiction parameter in the URL
          const jurisdictionParam = this.$stateParams.jurisdiction;
          console.log(this.$stateParams);
          if (jurisdictionParam) {
            this.$scope.currentJurisdiction = jurisdictionParam;
          } else if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        } else {
          if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        }

        console.log(this.$scope.currentJurisdiction);
        this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
        this.$scope.getStationAreaList(this.$scope.currentJurisdiction);
      })
      .catch(err => {
        console.log(err);
      });
  }

  getStationAreaSubmissionSummary(stationId) {
    console.log('Getting summary for station:', stationId);
    this.lookup.setCurrentStation(stationId);

    if (this.$scope.stationAreas.length > 0) {
      this.$scope.stationAreas.forEach(element => {
        element.active = element.sta_recid === stationId;
        if (element.active) {
          this.$scope.stationAreaTitle = element.station_name;
        }
      });

      return this.fetch.getItem(
        `api/data/policies/${this.$scope.currentJurisdiction}`,
        stationId
      )
        .then(response => {
          console.log('Policy data:', response);
          this.$scope.submissionSummary = response.data;
          console.log("submission summary: ", this.$scope.submissionSummary);

          // Process density submissions
          this.$scope.densitySubmissions = _.filter(response.data,
            { submission_policy_type: "Density" });
          this.$scope.densitySubmitted = _.filter(this.$scope.densitySubmissions,
            { submitted: true });
          this.$scope.densityCompliant = _.filter(this.$scope.densitySubmissions,
            { status: 'Consistent' });

          // Process housing policy submissions
          this.$scope.housingPolicySubmissions = _.filter(response.data,
            { submission_policy_type: "Housing Production Policy" });
          this.$scope.housingPolicySubmissions = _.union(
            this.$scope.housingPolicySubmissions,
            _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" })
          );
          this.$scope.housingPolicySubmitted = _.filter(
            this.$scope.housingPolicySubmissions,
            { submitted: true }
          );
          this.$scope.housingPolicyCompliant = _.filter(
            this.$scope.housingPolicySubmissions,
            { status: 'Consistent' }
          );

          // Process parking submissions
          this.$scope.parkingSubmissions = _.filter(response.data,
            { submission_policy_type: "Parking" });
          this.$scope.parkingSubmitted = _.filter(this.$scope.parkingSubmissions,
            { submitted: true });
          this.$scope.parkingCompliant = _.filter(this.$scope.parkingSubmissions,
            { status: 'Consistent' });

          // Process station access submissions
          this.$scope.stationAccessSubmissions = _.filter(response.data,
            { submission_policy_type: "Station Area Access" });
          this.$scope.stationAccessSubmitted = _.filter(
            this.$scope.stationAccessSubmissions,
            { submitted: true }
          );
          this.$scope.stationAccessCompliant = _.filter(
            this.$scope.stationAccessSubmissions,
            { status: 'Consistent' }
          );
        });

      this.$scope.loading = false;
    } else {
      this.$scope.stationAreaTitle = '--';
      return Promise.resolve();
    }
  }

}

export default angular.module('appApp.bicycle_parking', [uiRouter])
  .config(routes)
  .component('bicycleParking', {
    template: require('./bicycle_parking.html'),
    controller: BicycleParkingComponent,
    controllerAs: 'bicycleParkingCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/parking/bicycle_parking/bicycle_parking.component.js